import ymd from './01-ymd.js'
import mdy from './02-mdy.js'
import dmy from './03-dmy.js'
import misc from './04-misc.js'

export default [].concat(ymd, mdy, dmy, misc)
